import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import loanbox_Illustration from "../../webroot/images/sfa_node_bg.svg";
import logo from "../../webroot/images/logo.svg";

const Unauthorized = () => {
    useEffect(() => {
        let header = document.getElementsByClassName("header");
        if (header[0]) header[0].classList.add("hidden");
        let footer = document.getElementsByClassName("footer");
        if (footer[0]) footer[0].classList.add("hidden");

        return () => {
            if (header[0]) header[0].classList.remove("hidden");
            if (footer[0]) footer[0].classList.remove("hidden");
        };
    }, []);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="login-main">
                    <div className="login-outer">
                        <div className="login-left-panel">
                            <div className="login-bg">
                                <div className="logo-img">
                                    <img alt="" src={logo} className="" />
                                </div>
                                <div className="login-txt"></div>
                                <div className="login-bg-img">
                                    <img alt="" src={loanbox_Illustration} className="" />
                                </div>
                            </div>
                        </div>
                        <div className="login-right-panel error-404">
                            <div className="error-text">
                                <span>4</span>
                                <span className="shake-icon"><i className="ic-sad2"></i></span>
                                <span>3</span>
                            </div>
                            <p style={{ textAlign: 'center', color: '#666', fontSize: '16px', marginBottom: '20px' }}>
                                You don't have permission to access this page.
                            </p>
                            <div className="gotohome">
                                <NavLink to="/user-management">Go to Home</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;
